import styled from 'styled-components';
import Nationality from '../../../components/fields/NationalityField';
import { type Brightness } from '../../context';
import { PorscheSelectCss } from './shared';
import withPorscheSelect from './withPorscheSelect';

const PorscheNationalityField = styled(Nationality)<Brightness>`
    ${PorscheSelectCss}
`;

const NationalityField = withPorscheSelect(PorscheNationalityField);
export default NationalityField;
